import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useModal } from '../hooks/useModal';
// import Toast from './Toast';
import ToastBig from './ToastBig';
import Modal from './Modal';
import Sidebar from './Sidebar';
import SpinnerGlobal from './SpinnerGlobal';
import RouterSimple from './RouterSimple';
import Breadcrumbs from './Breadcrumbs';
import { selectObavestenja, selectRole, selectRouteSimple, selectSecondScreen } from '../redux/selectors';
import { actionRouteSecondScreenClose } from '../redux/actions';
import DisplayObavestenja from './DisplayObavestenja';
import StranaInicijalizacija from './StranaInicijalizacija';
import config from '../utils/config';
// import Z3dModal from './Z3dModal';
import { browser_utils } from '../utils/frfr-browser-utils';
import RouterSimpleSecondScreen from './RouterSimpleSecondScreen';

const Layout = (props) => {
  const dispatch = useDispatch();
  const { dispatchShowModal, dispatchCloseModal, dispatchShowToast } = useModal();
  const cheats = useSelector(state => state.app.cheats);
  const role = useSelector(selectRole);
  const obavestenja = useSelector(selectObavestenja);
  const routeSimple = useSelector(selectRouteSimple);
  const secondScreen = useSelector(selectSecondScreen);
  let route = routeSimple.route;
  let allow_admin_panel = false;
  if (role === 'ADMIN' || role === 'DEV') {
    allow_admin_panel = true;
  }

  const [appSubtitle, setAppSubtitle] = useState('SASTAVLJAČ DEMO');

  let jsx = null;
  if (Array.isArray(obavestenja) && obavestenja.length > 0) {
    jsx = (
      <span>{obavestenja.length}</span>
    );
  }
  const _click_zvonce = () => {
    const modalContent = (
      <DisplayObavestenja
        obavestenja={obavestenja}
      />
    );
    dispatchShowModal(modalContent);
  }

  const _second_screen_close = () => {
    dispatch(actionRouteSecondScreenClose());
  };

  let jsxEnv = null;
  const config_detected_env = config.detected_env;
  if (config_detected_env === 'LOCALHOST_DEV') {
    jsxEnv = (
      <div className="env-msg env-msg--local-dev">LOCALHOST DEV</div>
    );
  } else if (config_detected_env === 'PROD') {
    jsxEnv = null;
  } else if (config_detected_env === 'STG') {
    jsxEnv = (
      <div className="env-msg env-msg--testing env-msg--stg">OKRUŽENJE ZA TESTIRANJE: STG (Staging)</div>
    );
  } else if (config_detected_env === 'DEV') {
    jsxEnv = (
      <div className="env-msg env-msg--testing env-msg--dev">OKRUŽENJE: DEV</div>
    );
  } else {
    // TODO
    jsxEnv = (
      <div className="env-msg env-msg--testing">SPECIJALNO OKRUŽENJE</div>
    );
  }

  let jsxCheats = null;
  if (cheats && cheats.enabled === true) {
    jsxCheats = (
      <div className="env-msg env-msg--cheats-enabled">CHEATS</div>
    );
  }


  useEffect(() => {
    let _app_subtitle = 'SASTAVLJAČ DEMO';
    let webisteBrowserTitle = config.webisteBrowserTitle;
    if (config_detected_env === 'LOCALHOST_DEV') {
      _app_subtitle = 'SASTAVLJAČ';
    } else if (config_detected_env === 'PROD') {
      webisteBrowserTitle = config.webisteBrowserTitle_prod;
      _app_subtitle = 'SASTAVLJAČ';
    } else if (config_detected_env === 'STG') {
      webisteBrowserTitle = config.webisteBrowserTitle_stg;
      _app_subtitle = 'SASTAVLJAČ';
    } else if (config_detected_env === 'DEV') {
      webisteBrowserTitle = config.webisteBrowserTitle_dev;
      _app_subtitle = 'SASTAVLJAČ';
    } else {
      // TODO
    }
    browser_utils.browser_title_set(webisteBrowserTitle);
    setAppSubtitle(_app_subtitle);
  }, [config_detected_env]);


  //
  if (secondScreen.opened === true) {
    document.body.classList.add('second-screen-opened');
  } else {
    document.body.classList.remove('second-screen-opened');
  }


  return (
    <>
      <div className={"layout-second-screen" + (allow_admin_panel ? " scope-admin-panel" : "")}>
        <div className="layout-header header-universal222">
          <div className="layout-header-nav-back-btn" onClick={_second_screen_close}>
            <abbr title="Nazad u aplikaciju"><i className="fa fa-arrow-left" aria-hidden="true"></i></abbr>
          </div>
          <div className="layout-header-nav-back-btn" onClick={_second_screen_close}>
            <abbr title="Zatvori Admin Panel"><i className="fa fa-times" aria-hidden="true"></i></abbr>
          </div>
          <div className="fix-sidebar-push">
            <div className={"admin-panel-header-logo" + (allow_admin_panel ? "" : " admin-panel-header-logo--biblioteka")}><span className="termovent-sastavljac-logo-fig-bg"></span><span className="admin-panel-header-logo__text">{allow_admin_panel ? 'ADMIN PANEL' : (<abbr title="Termovent Baza/Biblioteka Inženjerskih Informacija">BIBL.</abbr>)}</span></div>
          </div>
          <div className="layout-header___gap-left"></div>
          <div className="logo uu-display-none">TERMOVENT DEMO ADMIN PANEL</div>
          <Breadcrumbs />
          {jsxEnv}
          {jsxCheats}
        </div>
        <div className="layout-wrapper">
          <div className="fix-sidebar-push layout-sidebar-bg"></div>
          <Sidebar
            app_subtitle={appSubtitle}
            modeAdminPanel={true}
          />
          <div className="layout-main">
            <div className="fix-header-push"></div>
            {
              secondScreen.opened === true && (
                (props.initialized_all === true || route === 'DEVPANEL') ? (
                  <RouterSimpleSecondScreen />
                ) : (
                  <StranaInicijalizacija />
                )
              )
            }
            {/*<div className="test">AP LAYOUT TEST AREA</div>*/}
          </div>
        </div>
      </div>
      <Modal />
      <ToastBig />
      <SpinnerGlobal />
      {/*<Z3dModal />*/}
      <div className="layout-wrapper">
        <Sidebar
          app_subtitle={appSubtitle}
        />
        <div className="layout-main">
          <div className="layout-header header-universal222">
            <div className="fix-sidebar-push"></div>
            <div className="layout-header___gap-left"></div>
            <div className="logo uu-display-none">TERMOVENT DEMO LOGO</div>
            <Breadcrumbs />
            {jsxEnv}
            {jsxCheats}
            <div className="flex-1"></div>
            <div className="zvonce clickable" onClick={_click_zvonce}>{jsx}<i className="fa fa-bell-o" aria-hidden="true"></i></div>
            {/*
            <div className="zvonce clickable" onClick={() => { }}><i className="fa fa-cog" aria-hidden="true"></i></div>
            */}
          </div>
          <div className="fix-header-push"></div>

          {
            (props.initialized_all === true || route === 'DEVPANEL') ? (
              <RouterSimple />
            ) : (
              <StranaInicijalizacija />
            )
          }

          <div className="layout-footer">Copyright © 2022 Žarko Turićanin, Dušan Mitrović</div>
        </div>
      </div>


    </>
  );
};

export default Layout;